export const customerQuotationList = "CUSTOMER_QUOTATION_LIST";
